import * as React from 'react'

import type { AllowanceIncidenceFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/Tooltip'
import { isHourlyFixedBalanceAllowance } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'
import type Allowance from 'modules/timeoff/store/models/Allowance'

import type { ParsedAllowanceStat } from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/allowanceStatUtils'

import Accrued from './Accrued'
import Carryovers, { CarryOver } from './Carryovers'
import Incidence from './Incidence'

interface Props {
  accrued: number
  carryOvers: CarryOver[]
  incidences: AllowanceIncidenceFragment[]
  allowance: Allowance
  stat: ParsedAllowanceStat
  thisCycle: string
}

const TotalBreakdown = ({ accrued, carryOvers, incidences, allowance, stat, thisCycle }: Props) => {
  const isHourlyFixedBalance = isHourlyFixedBalanceAllowance(allowance)

  const title = allowance.isDays
    ? i18n.t('time_off.new_counter.total_row.days')
    : i18n.t('time_off.new_counter.total_row.hours')

  const totalAdjustment = stat.attributes.incidences
  const totalCarryover = stat.attributes.accumulated_carry_over

  return (
    <Tooltip title={title}>
      <>
        <Accrued
          amount={accrued}
          thisCycle={thisCycle}
          isHourlyFixedBalance={isHourlyFixedBalance}
        />
        {Number(totalCarryover) !== 0 &&
          carryOvers.map((carry, index) => {
            return (
              carry.accumulated !== 0 && (
                <Carryovers
                  allowance={allowance}
                  carryOver={carry}
                  key={index}
                  isHourlyFixedBalance={isHourlyFixedBalance}
                />
              )
            )
          })}
        {totalAdjustment > 0 &&
          incidences.map((allowanceIncidence) => {
            return (
              allowanceIncidence.daysInCents > 0 && (
                <Incidence
                  key={allowanceIncidence.id}
                  allowanceIncidence={allowanceIncidence}
                  isHourlyFixedBalance={isHourlyFixedBalance}
                />
              )
            )
          })}
      </>
    </Tooltip>
  )
}

export default TotalBreakdown
